require("../jsgrid");
var dashboard = require("./downloadTransactionGraph");
var summaryChart = require("./summaryChart");
var sessionTimeoutPopup = require("./sessionTimeoutPopup");

var CustomCheckboxField = require("./datagridCustomFields/checkbox");
var CustomDateField = require("./datagridCustomFields/cleanDate");
var CustomDateFieldWithExtendedTag = require("./datagridCustomFields/dateWithExtendedTag");
var CustomDropdown = require("./datagridCustomFields/dropdown");
var CustomTableLinkField = require("./datagridCustomFields/tableLink");
var CustomTagField = require("./datagridCustomFields/tag");
var CustomTextField = require("./datagridCustomFields/textfield");

let dataGridPager = require("./dataGridPager");
let dataGridItemPager = require("./dataGridItemPager");
// assign the data grid pager based on the display format
let selectedDataGridPager = $('.pagination-summary-items').length ? dataGridItemPager : dataGridPager;

var utils = require("./utils");

var init = false;

function displayMessage($grid, message) {
  $grid.find(".grid-info-label").text(message);
}

function displayLoadingSpinner($grid) {
  let tableBody = $grid.find("table.jsgrid-table > tbody")
  tableBody.empty()
  $grid.find("div.jsgrid-pager").empty()
  $("#recordMessage").empty()
  let noOfColumns = $grid.find("tr.jsgrid-header-row th").length;
  tableBody.html(
      `<tr class="jsgrid-loaddata-row">
        <td class="jsgrid-cell" colSpan="${noOfColumns}">
          <div class="govuk-warning-text"><span class="govuk-warning-text__icon">!</span><strong
              class="govuk-warning-text__text grid-info-label">Please wait for the content to load.</strong>
            <div class="govuk-!-margin-bottom-5"></div>
            <div class="delta-animation-loading">
              <div class="delta-animation-loading-indicator">Data loading. Please wait.</div>
            </div>
          </div>
        </td>
      </tr>`
  )
}

function isInDataStorePage() {
  return $("#datastore-page").length > 0;
}

function isInDashboardPage() {
  return $("#dashboard-page").length > 0;
}

function isInCancelTransactionPage() {
  return $("#cancellationCommand").length > 0;
}

function isInAssociateOrgsPage() {
  return $("#associateOrganisations").length > 0;
}

function isInCollectionRequestPage() {
  return $("#collection-request-page").length > 0;
}

function isInSummaryChart() {
  return $("#summary-chart").length > 0;
}
function isInUserListPage() {
  return $("#userslist-page").length > 0;
}
function isInManageTransactionsPage() {
  return $("#manageTransactionsByGrant").length > 0;
}
function isInFormAuidtPage() {
  return $("#formAuditPage").length > 0;
}
// ------------------------------
// Constructor
// ------------------------------

/**
 * Initialise the grid and attach to a container
 * @param {jQuery} $target      - The grid container target jQuery element
 * @param {Object} gridOptions  - jsGrid options object
 * @param {Object} endpoints    - endpoints in use
 * @constructor
 */
var DataGrid = function ($target, gridOptions, endpoints) {
  window.DCLG = window.DCLG || {};

  // Registering custom 'fields' for DCLG dataGrid
  jsGrid.fields.checkboxDCLG = CustomCheckboxField;
  jsGrid.fields.tableLinkDCLG = CustomTableLinkField;
  jsGrid.fields.dateDCLG = CustomDateField;
  jsGrid.fields.dataDCLGWithExtendedTag = CustomDateFieldWithExtendedTag;
  jsGrid.fields.dropdownDCLG = CustomDropdown;
  jsGrid.fields.tagDCLG = CustomTagField;
  jsGrid.fields.text = CustomTextField;

  // Set options
  gridOptions = _getGridConfig(gridOptions || {});

  gridOptions.pageLoading = _loadByPage(gridOptions);

  function _loadByPage(gridOptions) {
    var loadByPage = gridOptions.pagination == "client" ? false : true;
    return loadByPage;
  }

  gridOptions.loadStrategy = _setPagingStrategy(gridOptions, $target);

  var $status = $('<div class="govuk-visually-hidden" role="status" aria-atomic="true"></div>');
  $target.before($status);
  $target.data("gridStatus", $status);

  gridOptions.controller = _getGridController(endpoints || {}, $target);

  // Update internal references
  this.$target = $target;

  window.DCLG.DataGrid = this;

  // Instantiate the grid
  $target.jsGrid(gridOptions);
  this.instance = $target.data("JSGrid");
  // Add any state needed between page loads to the instance under 'dclg'
  this.instance.dclg = {};

  _registerListeners.call(this, gridOptions);
  if (gridOptions.initialSort) {
    $target.jsGrid("sort", gridOptions.initialSort, "asc");
  }
};

// ------------------------------
// Private methods
// ------------------------------

/**
 * Get the grid controller
 * @param {Object} endpoints
 * @return {Object} JS Grid style controller
 * @private
 */
function _getGridController(endpoints, $target) {
  // Provide default values in the controller
  var defaults = {
    loadData: {
      type: "GET",
      url: "",
      dataMapper: "default",
    },
  };

  // extend pre-defined/imported configuration objects into 'customConfig'
  var customConfig = $.extend({}, defaults, endpoints);

  var key;
  var controller = {};

  for (key in customConfig) {
    if (customConfig.hasOwnProperty(key)) {
      // Prevent scope conflicts by using IIFE
      (function (controller, key, $grid) {
        switch (key) {
          case "loadData":
            controller[key] = loadDataHandler;
            break;
          case "deleteItem":
            controller[key] = deleteItemHandler;
            break;
        }

        function loadDataHandler(filter) {
          var d = $.Deferred();
          if (isInCancelTransactionPage()) {
            displayMessage(
              $grid,
              "Please select all of the above three filters to load the grid.",
            );
          } else {
            displayLoadingSpinner($grid);
          }
          if (isInDashboardPage()) {
            delete filter["pageIndex"];
            delete filter["pageSize"];
            if (filter["dateType"] != "approval-date") {
              filter["dateType"] = "payment-date";
            }
          }
          customConfig[key].data = filter;
          customConfig[key].beforeSend = function () {
            setUrl(customConfig[key].url, this.url, filter);
          };
          var serverSidePagination = $grid.data("JSGrid").option("pageLoading");
          if (isInDashboardPage()) {
            var formData = "/transactions-dashboard/get-dashboard-chart-data?";
            for (var i in filter) {
              if (i == "includeForecast") {
                if ($("#includeForecast").prop("checked") != true) {
                  formData = formData;
                } else {
                  formData =
                    formData + i + "=" + encodeURIComponent(filter[i]) + "&";
                }
              } else {
                formData =
                  formData + i + "=" + encodeURIComponent(filter[i]) + "&";
              }
            }
            var encodedFormData = formData
              .replace(/\[/g, "%5B")
              .replace(/\]/g, "%5D");
            sessionTimeoutPopup.sessionTimeout();
            $.ajax({
              dataType: "JSON",
              url: encodedFormData,
              beforeSend: function () {
                setUrl(customConfig[key].url, this.url, filter);
              },
            })
              .done(function (response) {
                barChart(response);
              })
              .fail(function (response) {
                //                                            barChart(response);
              });
          } else {
            sessionTimeoutPopup.sessionTimeout();
            $grid.requestCounter = $grid.requestCounter ? $grid.requestCounter + 1 : 1
            var requestCounter = $grid.requestCounter
            var $status = $grid.data("gridStatus");
            $status.text("Loading results.");
            $.ajax(customConfig[key]).done(function (response) {
              if(requestCounter !== $grid.requestCounter){
                return
              }
              if (isInSummaryChart()) {
                pieChart(response);
              }
              if (serverSidePagination) {
                var pager = $(".jsgrid-pager-container").attr("style");
                // Persist filters ONLY (no pageIndex/pageSize/sorting)
                var base = $.extend(true, {}, filter);
                delete base.pageIndex;
                delete base.pageSize;

                sessionStorage.setItem("baseParams", JSON.stringify(base));
                // Ensure this runs immediately
                var gridInstance = $grid.data("JSGrid");
                gridInstance.dclg = gridInstance.dclg || {};
                gridInstance.dclg.params = $.extend(true, {}, base); // clone

                if (isInDataStorePage()) {
                  if (response.itemsCount > 10) {
                    $("#recordMessage").text(
                      "Total records : " + response.itemsCount,
                    );
                  } else {
                    $("#recordMessage").text("");
                  }
                }
                if (isInCollectionRequestPage()) {
                  if (response.itemsCount > 10) {
                    $("#recordMessage").text(
                      "Total records : " + response.itemsCount,
                    );
                  } else {
                    $("#recordMessage").text("");
                  }
                }
                window.DCLG.GridData = {
                  data: response.data,
                  itemsCount: response.itemsCount
                    ? response.itemsCount
                    : response.data.length,
                };
              } else {
                // clientSide pagination
                window.DCLG.GridData = response.data;
              }
              d.resolve(window.DCLG.GridData);
              if (requestCounter === $grid.requestCounter) {
                $status.text(response.data.length ? "Results loaded." : "No information is available.");
              }
            }).fail(function (response) {
              if (requestCounter !== $grid.requestCounter) {
                return;
              }
              var message = "Results could not be loaded.";
              displayMessage($grid, message);
              $grid.find(".jsgrid-loaddata-row .delta-animation-loading").remove();
              $status.text(message);
              d.reject(response);
            });
          }
          return d.promise();
        }

        function setUrl(configUrl, thisUrl, filters) {

          var stringReplaceto = window.location.href.split("/");
          stringReplaceto = stringReplaceto
            .slice(stringReplaceto.length - 1)
            .join("/")
            .split("?")
            .slice(0, 1)
            .join("?")
            .replace("#", "");
          var stringReplaceFrom = configUrl.split("?").slice(0, 1).join("?");

          if (init == false) {
            window.history.pushState(
              null,
              "",
              thisUrl.replace(stringReplaceFrom, stringReplaceto),
            );
          } else {
            init = false;
          }
        }

        function barChart(response) {
          dashboard.displayChart(response);
        }
        function pieChart(response) {
          summaryChart.displayChart(response);
        }

        function deleteItemHandler(row) {
          var d = $.Deferred();
          var token = $("#_csrf").val();
          // Passing in the row to be deleted, along with the
          // expected pre-defined AJAX params in the deleteItem object
          var deleteRequest = $.extend({ data: row }, customConfig[key]);

          $.ajaxSetup({
            headers: { "X-CSRF-TOKEN": token },
          });

          $.ajax(deleteRequest).done(function (response) {
            d.resolve(response);
          });

          return d.promise();
        }
      })(controller, key, $target);
    }
  }

  return controller;
}

function onUsersListPage() {
  return $("#userslist-page").length > 0;
}

function _getGridConfig(options) {
  var config = $.extend(
    true,
    {
      autoload: true,
      initialSort: options.initialSort,
      confirmDeleting: false,
      editing: false,
      fields: [], // These fields must be supplied by the configuration object
      filtering: false,
      loadIndication: false,
      pagerRenderer: selectedDataGridPager,
      pageSize: 10,
      paging: true,
      noDataLinkText: null,
      noDataLinkURL: null,
      sorting: true,
      width: "100%",
      // height:     '1200px',
      gridBodyClass: "jsgrid-grid-header",

      onInit: function (args) {
        init = true;
        if ($("#error").text() != "") {
          $("#errorBlock").removeClass("visually-hidden");
        }
        // Clear any previously used sessionStorage items, just to be sure...
        sessionStorage.removeItem("sel");
        sessionStorage.removeItem("preloadedMonitor");
        sessionStorage.removeItem("gridSettings");
        sessionStorage.removeItem("baseParams");

        // Set the counter of the number of 'preloaded facets' to process
        var $preloaded = $("[data-facet-preloaded=true]");
        var preloadedCount = $preloaded.length;

        if (preloadedCount) {
          sessionStorage.setItem("preloadedMonitor", preloadedCount);
          $(".reset-all-filters").data("enabled", true);
        }
      },
      onDataLoading: function (args) {
        var action =
          stillProcessingPreloadedFilters(
            sessionStorage.getItem("preloadedMonitor"),
          ) || noOptionSelectedAndIsClientsidePaging();
        args.cancel = action;

        //fetch any freetext (search text) within the search box
        var freetextElement = document.getElementById("search-textfield")
        var freetext = freetextElement && freetextElement.value;

        if (freetext && !args.filter.freetext) //if freetext exists add it to the search params
        {
          args.filter.freetext = freetext;
        }

        function noOptionSelectedAndIsClientsidePaging() {
          return (
            _onUsersListPage() &&
            args.grid.pagination.toLowerCase() == "client" &&
            $.isEmptyObject(args.filter)
          );
        }

        function stillProcessingPreloadedFilters(tracker) {
          // If there are still any facets marked as 'preloaded',
          // decline triggering the grid request for data...
          if (tracker) {
            return parseInt(tracker, 10) > 0;
          }
          return false;
        }
        function _onUsersListPage() {
          return $("#userslist-page").length > 0;
        }
      },
      onDataLoaded: function (args) {
        displayMessage($(args.grid._container), "No information is available.");
        
        handleCellsWithoutSpans();

        // For dealing with when the table has 'noData' in which the row
        // spans across however many columns there are.
        // Before this fix, while the header columns would expand when the
        // 'Filters' are brought into view, the 'noData' row would not,
        // thus, presenting to the user a skewed view of the table.
        var $header = $(args.grid._headerGrid),
          $body = $(args.grid._bodyGrid),
          $controller = $(args.grid._container).closest(".govuk-main-wrapper");

        if (!args.data.length && $(".jsgrid-nodata-row").length) {
          $($header, $body).css("table-layout", "initial");
        }

        // Whenever there's fresh data loaded into the grid, fire off event
        // to checkbox.js to update its model to reflect this update in data...
        var checkboxModel = sessionStorage.getItem("sel");
        if (checkboxModel) {
          checkboxModel = JSON.parse(checkboxModel);
          checkboxModel.updatedData = args.data;
          sessionStorage.setItem("sel", JSON.stringify(checkboxModel));
          $controller.trigger("dclg.checkboxlist.model.update");
        }
        var $checkbox = $(".jsgrid").find('input[type="checkbox"]');
        if ($checkbox.length > 0) {
          $(".jsgrid-grid-body")
            .find('input[type="checkbox"]')
            .attr("aria-label", "checkbox");
        }

        if ($("#retired-orgs-warning").length) {
          for (let i = 0; i < args.data.length; i++) {
            if (
              args.data[i].retirementDate &&
              new Date(args.data[i].retirementDate) < new Date()
            ) {
              $("#retired-orgs-warning").show();
              break;
            }
          }
        }
      },
      onPageChanged: function (args) {
        var model = JSON.parse(sessionStorage.getItem("sel"));

        if (!$.isEmptyObject(model)) {
        }
      },
      onRefreshing: function (args) {
        if (isInGrantsDatasetsPage() || isInCertifierRolesPage()) {
          $(args.grid._container).css("min-height", "auto");
        } else {
          $(args.grid._container).css("min-height", "560px");
        }
        var currentPage = "page_" + args.grid.pageIndex;

      },
      onRefreshed: function (args) {
        handleCellsWithoutSpans();
      },

      onItemDeleted: function (args) {
        // // Ref: https://github.com/tabalinas/jsgrid/issues/4
        // console.log('grid state, row deletion', window.DCLG.GridData);
      },
      _createBody: function () {
        var $content = (this._content = $("<tbody>"));

        var $body = (this._body = this._headerGrid
          .append($content)
          .on(
            "scroll",
            $.proxy(function (e) {
              this._header.scrollLeft(e.target.scrollLeft);
            }, this),
          ));

        var $scrollContainer = $('<div class="data-grid-scroll-container" role="region" aria-label="Results table, scroll horizontally if needed" tabindex="0"></div>')
          .append($body);
        return $('<div class="data-grid-table-container"></div>')
          .append($scrollContainer);
      },
    },
    options,
  );

  config.noDataContent = noDataContentHandler.bind(config);

  config.pagination = config.pagination || "server";

  return config;
}

function isInGrantsDatasetsPage() {
  return $("#datasets-grid-page").length > 0;
}

function isInCertifierRolesPage() {
  return $("#certifier-roles-page").length > 0;
}
function handleCellsWithoutSpans() {
  var $cells = $(".jsgrid-cell, .jsgrid-header-cell");
  var $cellsWithoutInnerSpans = $cells.filter(function () {
    return $(this).find("span:first").length < 1;
  });

  var $wrapCell, $cell, shouldAddSortIcon, columnName;

  $cellsWithoutInnerSpans.each(function () {
    $wrapCell = $("<span>");
    $cell = $(this);
    shouldAddSortIcon = $cell.find(".sort-icon").length === 0;
    columnName = $.trim($cell.text());

    if ($cell.hasClass("jsgrid-header-sortable") && shouldAddSortIcon) {
      var $sortLink = $('<button type="button"></button>').attr("aria-label", columnName);
      var $icon = $('<span class="sort-icon sort-link" aria-hidden="true"></span>');
      $sortLink.append($icon);
      $wrapCell.wrapInner($sortLink);
    }

    $cell.wrapInner($wrapCell);
    $cell.css("max-width", $cell[0].style.width);
  });

  updateSortAriaState() // new — see below, satisfies AC2/AC3
}

function updateSortAriaState() {
  $(".jsgrid").each(function () {
    var $grid = $(this);
    var gridInstance = $grid.data("JSGrid");
    if (!gridInstance) return;

    var sorting = gridInstance.getSorting(); // { field, order }
    var $headers = $grid.find("th.jsgrid-header-sortable");

    $headers.each(function (index) {
      var field = gridInstance.fields && gridInstance.fields[index];
      var $th = $(this);
      if (field && sorting.field === field.name) {
        $th.attr("aria-sort", sorting.order === "desc" ? "descending" : "ascending");
      } else {
        $th.removeAttr("aria-sort");
      }
    })
  })
}

function noDataContentHandler() {
  var config = this;

  var $iconNoData = $("<span>").addClass("govuk-warning-text__icon").text("!");
  var $strongNoData = $(
    '<strong class="govuk-warning-text__text grid-info-label"></strong>',
  )
    .append($('<span class="govuk-visually-hidden">').text("Warning"))
    .text("No information is available.");
  if (isInUserListPage()) {
    $strongNoData = $(
      '<strong class="govuk-warning-text__text grid-info-label"></strong>',
    )
      .append($('<span class="govuk-visually-hidden">').text("Warning"))
      .text(
        "Enter a search term or select filter options.",
      );
  }

  // if no dataLinkText do not display a url
  var $linkNoData = config.noDataLinkText
    ? $("<a></a>")
        .attr("href", config.noDataLinkURL)
        .text(config.noDataLinkText)
    : null;

  var $banner = $("<div/>").addClass("govuk-warning-text");

  $banner.append($iconNoData, $strongNoData, $linkNoData);

  return $banner;
}

/**
 * Register the event listeners needed to trigger reloads
 * @private
 */
function _registerListeners() {
  var Datagrid = this;
  var initConfig = arguments[0];

  // For facets / freetext search
  Datagrid.$target.on("dclg.dataGrid.triggerReload", function (event, model) {
    // Update and fetch the 'preloaded-facet' counter, used for deciding when to
    // trigger a Datagrid reload

    var preloadedCount = _updatePreloadedFacetsCount();
    if (!preloadedCount || $.isEmptyObject(model.params)) {
      // if, this is the last-changed-facet, the FILTER now has all preloaded facet info
      // and thus, DataLoading can now continue...
      sessionStorage.removeItem("preloadedMonitor");

      // the assumption is it is greater than 0, and thus not the last, so CANCEL DataLoading...
      Datagrid.instance.dclg.params = utils.copyObject(model.params);

      if (onUsersListPage() && $.isEmptyObject(Datagrid.instance.dclg.params)) {
        Datagrid.$target.requestCounter = (Datagrid.$target.requestCounter || 0) + 1;
        Datagrid.$target.data("gridStatus").text("");
        Datagrid.$target.jsGrid("destroy");
        if (!$.isEmptyObject(initConfig)) {
          Datagrid.$target.jsGrid(initConfig);
        }
      } else {
        if (model.isInitialPageLoad) {
          Datagrid.$target.data("initialFilters", model);
          Datagrid.$target.jsGrid("loadData", model.params);
        }
        else {
          Datagrid.$target.jsGrid("search", model.params);
        }
      }
    } else {
      console.log(
        "CURRENT COUNT of preloaded-facets left to process:",
        preloadedCount,
      );
    }
  });
}

function _updatePreloadedFacetsCount() {
  var preloadedMonitor = sessionStorage.getItem("preloadedMonitor");

  if ($.isEmptyObject(preloadedMonitor)) {
    preloadedMonitor = 0;
  } else {
    preloadedMonitor = parseInt(preloadedMonitor, 10);

    preloadedMonitor = preloadedMonitor - 1;
    sessionStorage.setItem("preloadedMonitor", preloadedMonitor);
  }

  return preloadedMonitor;
}

/**
 * Set the pagination strategy to be 'client' or 'server' side.
 * When using checkboxes the pagination should be clientside so
 * that the 'select all' checkbox works between paging requests.
 * @param options
 * @private
 */
function _setPagingStrategy(options, $grid) {
  var DclgLoadingStrategy;

  switch (options.pagination) {
    case "client":
      DclgLoadingStrategy = function (grid) {
        jsGrid.loadStrategies.DirectLoadingStrategy.call(this, grid);
      };
      DclgLoadingStrategy.prototype =
        new jsGrid.loadStrategies.DirectLoadingStrategy();
      DclgLoadingStrategy.prototype.finishDelete = handleFinishDelete;
      break;
    case "server":
    /**
     * As we want paging to supply filters from outside the grid
     * we need to use a custom paging strategy to ensure external
     * search params are supplied when moving through pages.
     */
    default:
      DclgLoadingStrategy = function (grid) {
        jsGrid.loadStrategies.PageLoadingStrategy.call(this, grid);
      };
      DclgLoadingStrategy.prototype =
        new jsGrid.loadStrategies.PageLoadingStrategy();

      DclgLoadingStrategy.prototype.loadParams = serverLoadParams;


      break;
  }

  return function () {
    return new DclgLoadingStrategy(this);
  };
}

function serverLoadParams() {
  var grid = this._grid;

  const findRefreshingPage =
      window.filtersManager &&
      window.filtersManager.initialQueryParams === window.filtersManager.lastQueryParams;

  //Using live grids only when moving to different pages in the grid ---
  if (window.filtersManager && !window.filtersManager.lastQueryParams.hasOwnProperty('pageIndex') && !findRefreshingPage){
    var params = {
      pageIndex: 1,
      pageSize: 10,
    };
    if(grid.option("pageIndex") > 1){
      grid.option("pageIndex", 1); // reset the grid to 1
      grid.option("pageSize", 10);
    }

  }
  else{
    var params = {
      pageIndex: grid.option("pageIndex"),
      pageSize: grid.option("pageSize"),
    };
 }

  // Merge filters from grid.dclg.params (in-memory) ---
  grid.dclg = grid.dclg || {};
  grid.dclg.params = grid.dclg.params || {};
  $.extend(params, grid.dclg.params);

  //Initial load params (only once) and when nothing in memory ---
  if ((window.filtersManager &&
      window.filtersManager.initialQueryParams &&
      window.filtersManager.initialLoad)) {
    $.extend(grid.dclg.params, window.filtersManager.initialQueryParams);
    $.extend(params, window.filtersManager.initialQueryParams);

    window.filtersManager.loadedInitialParams();
  }

  // Sorting (preserve original behaviour) ---
  var sorting = grid.getSorting();

  var serverSortField = grid.option("serverSortField");
  var serverSortOrder = grid.option("serverSortOrder");

  if (!sorting.field && serverSortField && serverSortOrder) {
    sorting.field = serverSortField;
    sorting.order = serverSortOrder;
    setSortWithoutLoadingData(grid, sorting);
  }

  // Save sorting if present
  if (sorting.field && sorting.order) {
    sessionStorage.setItem("gridSettings", JSON.stringify({ sorting: sorting }));
  }

  // Reapply stored sorting
  var gridSettings = {};
  try {
    gridSettings = JSON.parse(sessionStorage.getItem("gridSettings")) || {};
  } catch (e) {
    gridSettings = {};
  }

  if (gridSettings.sorting && gridSettings.sorting.field && gridSettings.sorting.order) {
    $.extend(params, {
      sortField: gridSettings.sorting.field,
      sortOrder: gridSettings.sorting.order,
    });
  }

  return params;
}

function setSortWithoutLoadingData(grid, sorting) {
  grid._setSortingParams(sorting.field, sorting.order);
  grid._setSortingCss();
}

function handleFinishDelete(deletedItem, deletedItemIndex) {
  var grid = this._grid;
  grid.option("data").splice(deletedItemIndex, 1);
  grid.refresh();

  window.DCLG.GridData.data = grid.option("data");
  window.DCLG.GridData.itemsCount = window.DCLG.GridData.data.length;
}

// ------------------------------
// Public API
// ------------------------------

module.exports = DataGrid;
